import React from 'react';
import { useSelector } from 'react-redux';
import { useLoaderData, useNavigate } from 'react-router-dom';

import Location from '@r6digital/rapidstor-types/react/entities/Location';
import Persona from '@r6digital/rapidstor-types/types/Persona';

import store from '../../store';
import { selectIsAshford, setPersonaId } from '../../store/bookingSlice';

import classes from './FeaturesAndBenefits.module.scss';

import {
    ASH,
    BAR,
    GEP,
    LON,
    MEL,
    NOR,
    PAR,
    StaticLocations,
} from '../../features/features-and-benefits';
import { findPersonaId } from '../../features/helpers';

interface Props {
    storageType: string;
    personas: Persona[] | undefined;
}

export interface StaticContent {
    name: string;
    image: string;
    description: string;
}

function FeaturesAndBenefits({ storageType, personas }: Props) {
    const navigate = useNavigate();
    const location = useLoaderData() as Location;
    const isAshford = useSelector(selectIsAshford);

    const locationType: StaticLocations =
        {
            ASH: ASH,
            GEP: GEP,
            LON: LON,
            MEL: MEL,
            BAR: BAR,
            NOR: NOR,
            PAR: PAR,
        }[location.locationCode] ?? ASH;

    const personalTypes: StaticContent[] = locationType.personal;

    const businessTypes: StaticContent[] = locationType.business;

    const types = storageType === 'personal' ? personalTypes : businessTypes;

    return (
        <div
            className={`${classes.container}`}
            onClick={() => {
                store.dispatch(setPersonaId(findPersonaId(storageType, personas)));
                navigate(`/locations/${isAshford ? 'ashford' : location.slug}/units`);
            }}
        >
            <span className={`${classes.experience}`}>
                Experience the U-Store-It difference
            </span>
            <div className={`${classes.cards_container}`}>
                {types.map((type) => (
                    <div
                        className={`${classes.card}`}
                        key={type.name}
                        data-feature-and-benefit={type.name}
                    >
                        <img src={type.image} />
                        <div className={`${classes.card_body}`}>
                            <div className={`${classes.outer}`}>
                                <div className={`${classes.inner}`}>
                                    <span>{type.name}</span>
                                    {type.name.toLowerCase().includes('free move-in') && (
                                        <span className={classes.tcs}>* T&Cs apply</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <button
                className={`${classes.continue_button}`}
                onClick={() => {
                    store.dispatch(setPersonaId(findPersonaId(storageType, personas)));
                    navigate(`/locations/${isAshford ? 'ashford' : location.slug}/units`);
                }}
            >
                Continue
            </button>
        </div>
    );
}

export default FeaturesAndBenefits;
